import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function CheckItem({item, index, deleteInfo, setIdx, setIsOpenModal}) {

    const getDate = (date) => {
        if (!date) return
        const dateNum = new Date(date)
        const formatedDate = `${dateNum.getHours() > 9 ? dateNum.getHours() : "0" + dateNum.getHours()}:${dateNum.getMinutes() > 9 ? dateNum.getMinutes() : "0" + dateNum.getMinutes()} ${dateNum.getDate() > 9 ? dateNum.getDate() : "0" + dateNum.getDate()}/${dateNum.getMonth() > 8 ? dateNum.getMonth() + 1 : "0" + (dateNum.getMonth() + 1)}/${dateNum.getFullYear()}`
        return formatedDate
    }

  return (
    <div className='p-2 my-2'>
        <div className='grid grid-cols-4 gap-4'>
            <p className='border-r border-r-gray-500 flex items-center'>Ամսաթիվ</p> 
            <p className='border-r border-r-gray-500 flex items-center justify-center'>Ստուգող</p> 
            <p className='border-r border-r-gray-500 flex items-center justify-center'>Ծանոթություն</p> 
            <p className='w-full flex items-center justify-end text-end pr-4'>Ղեկավարման կոճակներ</p> 
        </div>
        <div className='grid grid-cols-4 gap-4'>
            <p className='border-r border-r-gray-500 flex items-center text-start py-2'>{getDate(item.date)}</p> 
            <p className='border-r border-r-gray-500 flex items-center justify-center py-2'>{item.checker}</p> 
            <p className='border-r border-r-gray-500 flex items-center justify-center py-2'>{item.acquaintance}</p> 
            <div className='w-full flex items-center justify-end pr-4'>
                <div className='flex gap-3 items-center'>
                    <FontAwesomeIcon icon={faPenToSquare} title="Խմբագրել" onClick={() =>{setIdx(index); setIsOpenModal(true)}} />
                    <FontAwesomeIcon icon={faTrash} title="Ջնջել" onClick={() => {deleteInfo(item._id)}}/>
                </div>
            </div>
        </div>
    </div>
  )
}
